import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const PublicitySection = () => (
  <>
    <SectionHeading>Publicity and Intellectual Property</SectionHeading>

    <ListItem marker="(a)">
      {"By participating in any Promotion, We may ask you to cooperate in advertising, marketing and/or publicity material and activities, at Our expense. You may also be asked (1) to wear any branded clothing or attire We may provide; and (2) to sign, if requested, an irrevocable release form allowing Us, without any compensation being payable to you, to use Your name, photograph, likeness, any comments made by or attributed to You, and to incorporate any such information and any audio/visual recording or broadcast for such promotional purposes, in any media, throughout the world."}
    </ListItem>

    <ListItem marker="(b)" withBottomMargin>
      {"Where You participate in any event which We host or arrange in connection with a Promotion, You agree not to make use of any third party branding or advertising for any organization which We consider to be Our competitor, including without limitation any branding or advertising for any other gaming company, and You agree not to conduct yourself in a manner that might, in Our reasonable opinion, bring us, any of Our affiliates or any of Our or their respective brands into disrepute. In the event of any breach of this requirement, We reserve the right not to award a Prize or to seek the return of any Prize awarded."}
    </ListItem>
  </>
);

export default PublicitySection;
